import { Link, useParams } from "react-router-dom";
import { useSimulatorConfiguration } from "./useSimulatorConfiguration";
import { ConfigurationViewGuard } from "./parts/ConfigurationViewGuard";
import { TicketChannelInstallSimulator } from "./ticket-channel/TicketChannelInstallSimulator";
import { QuackchatChannelInstallSimulator } from "./quackchat-channel/QuackchatChannelInstallSimulator";
import { SlackChannelInstallSimulator } from "./slack-channel/SlackChannelInstallSimulator";
import { Button, Flex } from "@radix-ui/themes";

export function InstallSimulator() {
  const { simulatorId } = useParams();
  const { simulator } = useSimulatorConfiguration(simulatorId);

  const channel = simulator?.channel;

  return (
    <ConfigurationViewGuard view={"install"}>
      {channel === "autonomous_ticket_event" && (
        <TicketChannelInstallSimulator />
      )}

      {channel === "autonomous_quackchat" && (
        <QuackchatChannelInstallSimulator simulatorId={simulatorId} />
      )}

      {channel === "slackbot" && <SlackChannelInstallSimulator />}

      {channel === "copilot" && (
        <Flex direction={"column"} gap={"8"}>
          <Flex direction={"column"} gap={"2"}>
            <h5>Install Quack Copilot</h5>
            <div>
              Add Quack to boost ticketing workflows and assist with actionable
              insights.
            </div>
            <img
              src={"/copilot.png"}
              alt="Quack Logo"
              className=" max-w-[700px]"
            />
          </Flex>
          <Flex gap={"2"}>
            <Link
              to={`https://chromewebstore.google.com/detail/quack-support-co-pilot/ipdeeefkkfmpcpamomgfmkjkidpkncme`}
              target="_blank"
            >
              <Button size={"1"} color="gray" highContrast variant="outline">
                Install Chrome Extension
              </Button>
            </Link>
            <Link to={`/settings/members`}>
              <Button size={"1"} color="gray" highContrast variant="outline">
                Invite your team
              </Button>
            </Link>
          </Flex>
        </Flex>
      )}
    </ConfigurationViewGuard>
  );
}
